const spacing = {
  xs: 4,
  sm: 8,
  md: 14,
  lg: 20,
  xlg: 32,
}

export default spacing
